// coherecommandr.component.ts
import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-coherecommandr',
  templateUrl: './coherecommandr.component.html',
  styleUrls: ['./coherecommandr.component.scss']
})
export class CoherecommandrComponent {
  constructor(private dialogRef: MatDialogRef<CoherecommandrComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}
